import { h } from 'preact'
import { PureComponent } from 'preact/compat'

import styles from './index.module.css'
import type { ContentType } from '../domain'

type FaktaboksProps = {
  id: string
  title: string
  text: Array<ContentType>
}

type FaktaboksState = {
  expanded: boolean
  maxHeight: string
}

export class Faktaboks extends PureComponent<FaktaboksProps, FaktaboksState> {
  element: HTMLElement

  constructor() {
    super()
    this.state = { expanded: false, maxHeight: '15px' }
  }

  toggleExpand(e: Event) {
    e.preventDefault()
    const expanded = !this.state.expanded
    const maxHeight = expanded ? `${this.element.scrollHeight}px` : '15px'
    this.setState({ expanded, maxHeight })
  }

  render() {
    return (
      <div className={styles.faktaboks}>
        <aside id={this.props.id} className={this.state.expanded ? styles.expanded : ''}>
          <h3>{this.props.title}</h3>
          <a href={`#${this.props.id}`} onClick={(e) => this.toggleExpand(e)}>
            <svg>
              <title>Ekspandér faktaboks</title>
              <use xmlnsXlink="http://www.w3.org/1999/xlink" xlinkHref="#nrk-chevron-down" />
            </svg>
          </a>
          <div
            style={{ maxHeight: this.state.maxHeight }}
            ref={(element: any) => {
              this.element = element
            }}
            aria-hidden={!this.state.expanded}
          >
            <ul>
              {this.props.text.map((text, idx) => {
                if (text.type === 'text') {
                  return <li key={idx} dangerouslySetInnerHTML={{ __html: text.value }} />
                } else {
                  return null
                }
              })}
            </ul>
          </div>
        </aside>
      </div>
    )
  }
}
